import { LayoutComponent } from '../layout/layout.component';
import { DomainComponent } from './domain/domain.component';
import {DomainGuard, AuthGuard, CompanyGuard, RedirectToGuard} from '../shared/guards';

export const routes = [
    {   path: '', component: DomainComponent },
    {   path: '', loadChildren: './auth/auth.module#AuthModule' }, // Guards applied inside
    {   path: 'company', loadChildren: './company/company.module#CompanyModule', canActivate: [ DomainGuard, AuthGuard ] },
    {
        path: '',
        component: LayoutComponent,
        children: [
            {
                path: 'products',
                loadChildren: './products/products.module#ProductsModule',
                canActivate: [ RedirectToGuard, DomainGuard, AuthGuard, CompanyGuard ]
            },
            {
                path: 'cart',
                loadChildren: './cart/cart.module#CartModule',
                canActivate: [ RedirectToGuard, DomainGuard, AuthGuard, CompanyGuard ]
            },
            {
                path: 'checkout',
                loadChildren: './checkout/checkout.module#CheckoutModule',
                canActivate: [ RedirectToGuard, DomainGuard, AuthGuard, CompanyGuard ]
            },
            {
                path: 'my-account',
                loadChildren: './my-account/my-account.module#MyAccountModule'
            }
        ]
    },

    // Not found
    { path: '**', redirectTo: 'products' }

];



// WEBPACK FOOTER //
// /opt/build/repo/src/app/routes/routes.ts